import { GetterTree } from "vuex";
import { RootState } from "./types";

const getDrawerState = "getDrawerState";

const n = {
  getDrawerState
};

const getterTree: GetterTree<RootState, RootState> = {
  [n.getDrawerState](state): any {
    return state.drawer;
  }
};

export { n as getterNames, getterTree as getters };
